// extracted by mini-css-extract-plugin
export var actionButton = "_b1-1";
export var actionButtons = "_b1-2";
export var actions = "_b1-0";
export var aiUnread = "_b1-10";
export var alignCenter = "_b1-h";
export var backWrapper = "_b1-3";
export var cellContainer = "_b1-4";
export var checkboxContainer = "_b1-5";
export var contentContainer = "_b1-6";
export var contentHeader = "_b1-8";
export var conversationsTableWrapper = "_b1-s";
export var draftReplyBadgeContainer = "_b1-m";
export var dropdownItem = "_b1-b";
export var dropdownItemsContainer = "_b1-a";
export var dropdownTitle = "_b1-c";
export var errorIcon = "_b1-7";
export var filter = "_b1-d";
export var gray = "_b1-i";
export var headerActionButtons = "_b1-e";
export var headerCheckboxContainer = "_b1-f";
export var icon = "_b1-j";
export var menuContainer = "_b1-k";
export var noMoreTicketsIcon = "_b1-12";
export var noMoreTicketsSubText = "_b1-13";
export var oneLine = "_b1-l";
export var optionsButton = "_b1-n";
export var plus = "_b1-o";
export var portalButtonsWrapper = "_b1-g";
export var red = "_b1-p";
export var scrolledTop = "_b1-9";
export var search = "_b1-q";
export var selectedConversationsCount = "_b1-r";
export var spinner = "_b1-t";
export var strong = "_b1-u";
export var summaryCell = "_b1-v";
export var tableContainer = "_b1-11";
export var tagContainer = "_b1-w";
export var threeDots = "_b1-x";
export var twoLines = "_b1-y";
export var unread = "_b1-z";